import React from 'react';
import AppBar from 'components/app-bar/app-bar';

export default function StatisticsRouter() {
  return <AppBar title="Statistics"></AppBar>;
}
